import { useCallback } from "react";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionMinimumBuyableNumPerTarget = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { minimumBuyableNumPerTarget } = viewModel;

	const onSetMinimumBuyableNumPerTarget = useCallback(
		(value: number | undefined) => {
			onSetViewModel([
				{
					key: "minimumBuyableNumPerTarget",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isEdited: minimumBuyableNumPerTarget?.isEdited ?? false,
		hasError: Boolean(minimumBuyableNumPerTarget?.error),

		minimumBuyableNumPerTarget,
		onSetMinimumBuyableNumPerTarget,
	};
};
